import React, { useState, useEffect } from 'react';

const SimpleBackgroundRotator = ({ imageUrls, interval = 10000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    console.log('Current index:', currentIndex);
    const timer = setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % imageUrls.length);
    }, interval);
    return () => clearTimeout(timer);
  }, [currentIndex, imageUrls.length, interval]);

  return (
    <div style={{ display: 'block',
      height: '100%', width: '100%',
      position: 'absolute',
   
      top: 0,
      left: 0,
      overflow: 'hidden'
     }}>
      <img
        src={imageUrls[currentIndex]}
        alt="background"
        style={{
          width: '100%',
          height: '100%',
          objectFit: "contain",
          transition: 'opacity 1s ease-in-out',
        }}
      />
    </div>
  );
};

export default SimpleBackgroundRotator;
